"use strict";
exports.__esModule = true;
exports.shouldShowFieldInList = exports.shouldShowFieldInView = exports.shouldShowFieldInForm = exports.mapTypes = void 0;
exports.mapTypes = function (field) {
    var type = field.ux || field.type;
    switch (type) {
        case 'autocomplete':
        case 'checkbox':
        case 'date':
            return type;
        case 'boolean':
            return 'switch';
        default:
            return 'default';
    }
};
exports.shouldShowFieldInForm = function (f, isAdd) {
    if (typeof isAdd === 'undefined' || !isAdd) {
        if (typeof f.hide !== 'undefined') {
            return !f.hide.detail && !f.hide.update;
        }
        return !f.hideInDetail && !f.hideInUpdate;
    }
    if (typeof f.hide !== 'undefined') {
        return !f.hide.add;
    }
    return true;
};
exports.shouldShowFieldInView = function (f) {
    if (typeof f.hide !== 'undefined' &&
        (typeof f.hide.detail !== 'undefined' || typeof f.hide.view !== 'undefined')) {
        return !f.hide.detail && !f.hide.view;
    }
    return !f.hideInDetail && !f.hideInView;
};
exports.shouldShowFieldInList = function (f) {
    if (typeof f.hide !== 'undefined' && typeof f.hide.list !== 'undefined') {
        return !f.hide.list;
    }
    return !f.hideInList;
};
